// Copyright (c) 2016 Deere & Company

import actions from '../../actions-list';
import {getDefaultState as getCustomerDefaultState} from '@deere/cps-it.warranty-model-factory/lib/customer';

export const resetCustomer = () => ({
    data: getCustomerDefaultState(),
    type: actions.RESET_PIP_CODE_REQUEST_CUSTOMER_STATE
});



// WEBPACK FOOTER //
// ./src/pip/pip-code/action-creators/reset-customer.js